import { render, staticRenderFns } from "./Cctv.vue?vue&type=template&id=99735b56&scoped=true"
import script from "./Cctv.vue?vue&type=script&lang=js"
export * from "./Cctv.vue?vue&type=script&lang=js"
import style0 from "./Cctv.vue?vue&type=style&index=0&id=99735b56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99735b56",
  null
  
)

export default component.exports